module.exports = __webpack_public_path__ + "img/help_icon_selected1.b4bf0dcd.svg";